<script setup lang="ts">
import * as R from 'ramda'

import {
  BaseballIncidentId,
  IncidentId,
} from '@collector/sportsapi-client-legacy'
import { Incident } from '@collector/sportsapi-types'
import ConfirmIncident from '@desktop/views/Relation/components/RelationView/Main/IncidentsToConfirm/ConfirmIncident.vue'
import { useTeamSides } from '@desktop/views/Relation/composables'
import { useIncidentName } from '@desktop/views/Relation/Sports/composables'

interface Props {
  incident: Incident
}

defineProps<Props>()

// composables
const { getIncidentName } = useIncidentName()
const { getIncidentTeamSide } = useTeamSides()

// methods
function getName(incidentId: IncidentId): string {
  return incidentId === BaseballIncidentId.HomeRun
    ? 'HR'
    : getIncidentName(incidentId)
}

function hasEmptyScore(incident: Incident): boolean {
  return R.isNil(incident.home_score2) && R.isNil(incident.away_score2)
}
</script>

<template>
  <ConfirmIncident
    :incident
    :teamSide="getIncidentTeamSide(incident)!"
  >
    <div class="text-2xs flex flex-col px-2 font-bold">
      <div class="text-center">
        {{ getName(incident.incident_id) }}
      </div>
      <div
        class="w-10 text-center text-nowrap"
        :class="{ invisible: hasEmptyScore(incident) }"
      >
        {{ incident.home_score2 }} - {{ incident.away_score2 }}
      </div>
    </div>
  </ConfirmIncident>
</template>
